import React from 'react';
import { Treemap, ResponsiveContainer, Tooltip } from 'recharts';
import { CustomizedContent } from './TreeChartCellRenderer';
import type { CategoryData } from '../utils';
import { Box, Typography } from '@mui/material';
import { ThemePalette } from 'mui.theme';

const COLORS = ['#4683E6'];

const CustomTooltip: React.FC<{
  active?: boolean;
  payload?: any;
  label?: string;
  enableDarkTheme: boolean;
}> = ({ active, payload, label, enableDarkTheme }) => {
  if (active && payload && payload.length) {
    const hoverCell = payload[0].payload;

    return (
      <>
        <Box
          sx={{
            backgroundColor: enableDarkTheme
              ? ThemePalette.dark.pageBackground
              : ThemePalette.light.pageBackground,
            padding: '10px',
          }}
        >
          <Typography
            sx={{
              color: enableDarkTheme
                ? ThemePalette.typography.grey
                : ThemePalette.typography.black,
            }}
            variant="body2"
          >
            Component: {hoverCell.name}
          </Typography>
          <Typography
            sx={{
              color: enableDarkTheme
                ? ThemePalette.typography.grey
                : ThemePalette.typography.black,
            }}
            variant="body2"
          >
            Total Cost: {hoverCell.totalCost}{' '}
          </Typography>
          <Typography
            sx={{
              color: enableDarkTheme
                ? ThemePalette.typography.grey
                : ThemePalette.typography.black,
            }}
            variant="body2"
          >
            Total Hours: {hoverCell.totalHours}{' '}
          </Typography>
          <Typography
            sx={{
              color: enableDarkTheme
                ? ThemePalette.typography.grey
                : ThemePalette.typography.black,
            }}
            variant="body2"
          >
            Total Part Cost: {hoverCell.totalWorkOrders}{' '}
          </Typography>
        </Box>
      </>
    );
  }

  return null;
};

export const ComponentsTreeChart = ({
  selectedCell,
  handleCellClick,
  data,
  enableDarkTheme = false,
}: {
  selectedCell: string;
  handleCellClick: any;
  data: CategoryData[];
  enableDarkTheme: boolean;
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <Treemap
        width={500}
        height={600}
        data={data}
        dataKey="totalCost"
        aspectRatio={4 / 3}
        stroke="#fff"
        content={
          // @ts-expect-error error exists in ts with chart library
          <CustomizedContent
            colors={COLORS}
            onClick={handleCellClick}
            selectedCell={selectedCell}
            enableDarkTheme={enableDarkTheme}
          />
        }
      >
        <Tooltip
          content={<CustomTooltip enableDarkTheme={enableDarkTheme} />}
        />
      </Treemap>
    </ResponsiveContainer>
  );
};

interface CustomizedContentProps {
  root: any;
  depth: number;
  x: number;
  y: number;
  width: number;
  height: number;
  index: number;
  colors: string[];
  name: string;
  selectedCell: string;
  onClick: (name: string) => void;
  enableDarkTheme: boolean;
}
